const INITIAL_PAGE_ITEMS_COUNT = 8;
/**
 * @param {number} reviewsLength
 * @returns {{ totalPages: number, options: {value:number, displayValue:string}[]}}
 */
export const useReviewerProfilePagination = (reviewsLength = 0) => {
  const totalPages = reviewsLength <= INITIAL_PAGE_ITEMS_COUNT
    ? 1
    : Math.ceil(reviewsLength / INITIAL_PAGE_ITEMS_COUNT);

  const options = Array.from({ length: totalPages })
    .map((_, i) => ({
      value: i + 1,
      displayValue: `${i + 1} of ${totalPages}`,
    }));

  return {
    totalPages,
    options,
  };
};

export default useReviewerProfilePagination;
